import * as React from 'react';
import { ArticleParagraph1, UIText1 } from '@cian/ui-kit';
import { Accordion, ComponentWithInnerHTML } from '@cian/frontend-e2e-deal-component';

import { useSimpleModal } from '../../../../utils/useSimpleModal';
import { ISberPremierExtraService } from '../../../../types/promoInfo';
import { CommonDealDetailsModal } from '../../../CommonDealDetails';
import { ListWithIcons } from '../../../ListWithIcons';

import * as styles from './styles.css';
export interface ISberPremierDetailsModalProps {
  presentation: ISberPremierExtraService['presentation'];
  activator: (activate: () => void) => React.ReactNode;
}

/**
 * Модалка с подробностями услуги
 * */
export const SberPremierDetailsModal: React.FC<ISberPremierDetailsModalProps> = props => {
  const { activator, presentation } = props;

  const [isOpen, onOpen, onClose] = useSimpleModal();

  return (
    <>
      {activator(onOpen)}
      <CommonDealDetailsModal open={isOpen} onClose={onClose} title={presentation.title} picture={presentation.picture}>
        <ArticleParagraph1>{presentation.description}</ArticleParagraph1>
        <ListWithIcons.List>
          {presentation.advantages.map((advantage, index) => (
            <ListWithIcons.Item key={index}>{advantage}</ListWithIcons.Item>
          ))}
        </ListWithIcons.List>
        <div className={styles['faq-container']}>
          {presentation.faq.map((question, index) => {
            return (
              <Accordion title={question.title} key={index}>
                <UIText1>
                  <ComponentWithInnerHTML className={styles['faq-html-insert']} html={question.description} />
                </UIText1>
              </Accordion>
            );
          })}
        </div>
      </CommonDealDetailsModal>
    </>
  );
};

SberPremierDetailsModal.displayName = 'ServiceDetailsModal';
